exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (min-width: 1400px) {\n.container[data-v-8f341b20] {\n    width: 1360px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1680px) {\n.container[data-v-8f341b20] {\n    width: 1640px;\n    max-width: 100%;\n}\n}\n@media (min-width: 1920px) {\n.container[data-v-8f341b20] {\n    width: 1860px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2560px) {\n.container[data-v-8f341b20] {\n    width: 2460px;\n    max-width: 100%;\n}\n}\n@media (min-width: 2880px) {\n.container[data-v-8f341b20] {\n    width: 2620px;\n    max-width: 100%;\n}\n}\n@media (min-width: 3840px) {\n.container[data-v-8f341b20] {\n    width: 3550px;\n    max-width: 100%;\n}\n}\n.text-dark[data-v-8f341b20] {\n  font-weight: 600;\n  font-size: 12pt;\n  color: #000 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8f341b20","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/user-registration/UserRegistration.vue
// module id = 685
// module chunks = 1